export const isGtmDebugMode = (): boolean => {
    if (typeof window === "undefined") {
        return false;
    };
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("gtm_debug")) {
        return true;
    }
    return false;
};
